<template>
    <div class="submit-image-container" @click="toggle" :class="{ selected }">
        <img v-if="resolvedImageUrl" :src="resolvedImageUrl" class="submit-image">
        <p>{{ name }}</p>
    </div>
</template>

<script setup>
import apiService from '@/services/apiService'
import { onMounted, ref } from 'vue'

const props = defineProps({
    id: Number,
    name: String,
    path: String,
    allowMoreSelection: Boolean
})

const resolvedImageUrl = ref(null)

const emit = defineEmits(['toggle'])
const selected = ref(false);

onMounted(async () => {
    const response = await apiService.getImageSignedUrl(props.id)
   resolvedImageUrl.value = response.url
})

function toggle() {
    if (selected.value) {
        selected.value = false;
        emit('toggle', {
            id: props.id,
            selected: selected.value
        })
    } else if (!selected.value && props.allowMoreSelection) {
        selected.value = true;
        emit('toggle', {
            id: props.id,
            selected: selected.value
        })
    }
}
</script>

<style scoped>
.submit-image-container {
    width: 25%;
    border: 1px solid lightgray;
    padding: 1rem;
    border-radius: 10px;
}

.selected {
    border: 3px solid #13294B;
}

.submit-image {
    width: 100%;
    height: auto;
}
</style>